import merge from "deepmerge";
import defaultConfig from './default-config';

export default class PushApiClient {
  constructor(config) {
    this.config = merge(defaultConfig, config);
    this.apiConfig = this.config.app.api;
    this.headers = {
      "Authorization": this.getAuthorization(),
      "Content-Type": "application/json"
    };
  }

  getAuthorization() {
    return "Bearer " + this.apiConfig.accessToken;
  }

  postData(body, endpoint) {
    try {
      return fetch(this.apiConfig.baseUrl + endpoint, {
        method: "POST",
        headers: this.headers,
        body: JSON.stringify(body)
      }).then(response => {
        if (response.ok) {
          return response
            .clone()
            .json()
            .catch(() => {
              let text = response.clone().text();
              return text;
            });
        }
        throw new Error("Error on endpoint:" + endpoint);
      }
      );
    } catch (error) {
      console.log("Error on endpoint:" + endpoint, error);
    }
  }

  getTags() {
    return this.postData({ appId: this.apiConfig.id, platformId: this.apiConfig.platformId }, "tags");
  }

  getSubscribedTags(device) {
    return this.postData({ appId: this.apiConfig.id, platformId: this.apiConfig.platformId, deviceId: device.id }, "list");
  }

  subscribe(device, tags) {
    return this.postData(
      {
        tagId: tags,
        appId: this.apiConfig.id,
        appVersion: 'webclient-3.0',
        platformId: this.apiConfig.platformId,
        deviceId: device.getId()
      },
      "reg"
    );
  }

  unsubscribe(device, tags) {
    return this.postData(
      {
        tagId: tags,
        appId: this.apiConfig.id,
        platformId: this.apiConfig.platformId,
        deviceId: device.getId()
      },
      "ureg"
    );
  }
}
